export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000
